module.exports = __webpack_public_path__ + "static/media/modern-building.5e466dfc.jpg";